import {onFind} from "@elements/init-modules-in-scope";
import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:
import * as scrollSlider from '@elements/scroll-slider';
scrollSlider.init();

import * as priceTable from './scripts/price-table.js';
priceTable.init();

import * as calcRoute from './scripts/calculate-route.js';
calcRoute.init();

import Collapse from 'bootstrap/js/dist/collapse';
onFind('[data-bs-toggle="collapse"]',function (element) {
    new Collapse(element);
});

import Popover from 'bootstrap/js/dist/popover';
onFind('[data-bs-toggle="popover"]',function (element) {
    new Popover(element);
});

import * as lazyIframe from '@elements/lazy-iframe';
lazyIframe.init();

import * as ajaxModal from './scripts/ajax-modal';
ajaxModal.init();

import * as ajaxAccordion from './scripts/ajax-accordion';
ajaxAccordion.init();

import * as formValidation from '@elements/form-validation';
formValidation.init();

import * as passwordStrength from './scripts/password-strength';
passwordStrength.init();

import * as passwordRepeat from './scripts/password-repeat';
passwordRepeat.init();

import * as validateGuestcard from './scripts/validate-guestcard';
validateGuestcard.init();

import * as validateZip from './scripts/validate-zip';
validateZip.init();

import * as fileInput from './scripts/file-input';
fileInput.init();

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init();

import * as fancySelect from './scripts/fancy-select';
fancySelect.init();

import * as submitToggleTimeout from './scripts/submit-toggle-timeout';
submitToggleTimeout.init();

import * as recaptcha from './scripts/recaptcha';
recaptcha.init();

import * as keycard from './scripts/keycard';
keycard.init();

import * as imaskPayment from './scripts/imask-payment';
imaskPayment.init();

